export const HELP_CENTER = 'https://homefi.gorgias.help/en-US';
export const getReturnGoLink = (email = '', orderNumber = '') => {
  return `https://homefi.info/a/returns?email=${encodeURIComponent(
    email,
  )}&orderId=${encodeURIComponent(orderNumber)}`;
};
